export default "__VITE_ASSET__f8f0338c__"